import { ActionIcon, Modal } from "@mantine/core";
import { IconHistory, IconPlus, IconTrash } from "@tabler/icons-react";
import { Fragment, useState } from "react";

import { usePostApi, useTheme } from "../../../../../../../hooks";
import { useDispatch } from "../../../../../../../redux/hooks";
import {
  addDynamicRow,
  removeDynamicRow,
  setModalProps,
} from "../../../../../../../redux/slices/medicalHistorySlice";
import { Flex, StyledTd, StyledTr } from "../../../../../../../styled";
import ConfirmationButton from "../../../../../../shared/ConfirmationButton/ConfirmationButton";
import MedicalInput from "../../Inputs/MedicalInput";
import { getMedIdType } from "../../utils/getMedIdType";
import { type IMedicalRow } from "../MedicalSections.model";

interface Props {
  index: number;
  sectionId: string;
  rowsLength: number;
  dataKey: string;
  row: IMedicalRow;
  history?: boolean;
}

const MedicalDynamicRow = ({
  index,
  sectionId,
  rowsLength,
  dataKey,
  row,
  history,
}: Props) => {
  const theme = useTheme() as any;
  const dispatch = useDispatch();
  const { post, isLoading } = usePostApi();

  const handleRemoveRow = async () => {
    const idType = getMedIdType(dataKey);
    const id = (row as any)[idType];
    if (id) {
      await post({
        request: "archive-med-log-row",
        body: {
          params: {
            section:
              dataKey === "medMedications" ? "medMedicationUsage" : dataKey,
            [idType]: id,
          },
        },
      });
    }
    dispatch(removeDynamicRow({ sectionId, rowIndex: index }));
  };
  const handleViewHistory = () => {
    dispatch(
      setModalProps({
        section: dataKey,
        id: (row as any)[getMedIdType(dataKey)],
      }),
    );
  };
  return (
    <Fragment>
      <StyledTr>
        {row.inputs.map((input, index) => (
          <StyledTd
            key={`${input.name}-${Math.random()}`}
            style={{ padding: "4px" }}>
            <MedicalInput
              {...input}
              history={history}
              vaxid={
                dataKey === "medVaccinations"
                  ? (row as any)[getMedIdType(dataKey)]
                  : undefined
              }
            />
          </StyledTd>
        ))}
        {!history && (
          <StyledTd>
            <Flex
              gap={2}
              style={{
                justifyContent:
                  !(index !== 0 || rowsLength > 1) && index === rowsLength - 1
                    ? "flex-end"
                    : "flex-start",
              }}>
              {index !== 0 || rowsLength > 1 ? (
                <ConfirmationButton
                  modalText="Are you your sure you want to archive this row?"
                  actionIcon
                  actionIconProps={{ c: "red" }}
                  onConfirm={handleRemoveRow}>
                  <IconTrash />
                </ConfirmationButton>
              ) : (
                <Flex w="28">&nbsp;</Flex>
              )}
              <ActionIcon onClick={handleViewHistory}>
                <IconHistory />
              </ActionIcon>
              {index === rowsLength - 1 ? (
                <ActionIcon
                  onClick={() => dispatch(addDynamicRow({ sectionId }))}>
                  <IconPlus />
                </ActionIcon>
              ) : (
                <Flex w="28">&nbsp;</Flex>
              )}
            </Flex>
          </StyledTd>
        )}
      </StyledTr>
    </Fragment>
  );
};
export default MedicalDynamicRow;
